import TableContent from './TableContent'
import ModalCreate from './ModalCreate'
import ModalEdit from './ModalEdit'

export {
  TableContent,
  ModalCreate,
  ModalEdit
}



// WEBPACK FOOTER //
// ./src/views/Divisions/components/index.js